<template>
  <div class="subjective-list-box">
    <div class="subjective-list-rectangle">{{sign}}</div>
    <div class=" subjective-list-title">
      <p>{{ name }}</p>
      <p v-if="from_page" class="subjective-list-sub-title">{{pageText}}</p>
      <div v-else>
        <p v-if="flowType == 3" class="subjective-list-sub-title"> মার্কড প্রশ্ন সংখ্যা: {{ englishToBengaliNumber(marked) }}</p>
        <p v-else class="subjective-list-sub-title">প্রশ্ন সংখ্যা: {{ englishToBengaliNumber(questions_count) }}</p>
      </div>
    </div>
    <div class="subjective-list-arrow" >
      <svg
          class="subjective-arrow"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M13.2673 4.20926C12.9674 3.92357 12.4926 3.93511 12.2069 4.23504C11.9212 4.53497 11.9328 5.0097 12.2327 5.29539L18.4841 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75H18.4842L12.2327 18.7047C11.9328 18.9904 11.9212 19.4651 12.2069 19.7651C12.4926 20.065 12.9674 20.0765 13.2673 19.7908L20.6862 12.7241C20.8551 12.5632 20.9551 12.358 20.9861 12.1446C20.9952 12.0978 21 12.0495 21 12C21 11.9504 20.9952 11.902 20.986 11.8551C20.955 11.6419 20.855 11.4368 20.6862 11.276L13.2673 4.20926Z"
            fill="#0095FF"
        />
      </svg>
    </div>
  </div>

</template>

<script>
import { englishToBengaliNumber } from "@/config/utils";
export default {
    props: [
        'flowType',
        'name',
        'sign',
        'questions_count',
        'marked',
        'from_page',
        'pageText',
    ],
  setup( ){
      return {
        englishToBengaliNumber,
      }
  }
}
</script>

<style scoped>
.left-align {
    text-align: left;
    text-align: left;
    margin-left: 1rem;

}

.align-center{
    align-items: center;
}

.top-div {
    margin-top: 0.06rem;
    background-color: rgba(17, 16, 16, 0.842);
}

.img-fluid {
    max-width: 65%;
    height: auto;
}

.subjective-list-button {
  background: #ffffff;
  border-radius: 16px;
  border-style: solid;
  border-color: #e6e4e4;
  border-width: 1px;
  opacity: 0.9599999785423279;
  height: 80px;
  position: relative;
  display: grid;
  justify-content: center;
  align-content: center;
  grid-template-columns: 1.1fr 2fr 1fr;
  grid-gap: 12px;
}

.subjective-list-button-icon {
  background: #fff5f6;
  border-radius: 10%;
  width: 60px;
  height: 60px;
  position: relative;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: 1;
}

.subjective-list-box {
  height: 245px;
  width: 258px;
  border-radius: 18px;
  border: 2px solid rgb(0 0 0 / 5%);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.subjective-list-rectangle {
  border-radius: 12px;
  position: relative;
  overflow: visible;
  grid-column: 1/5;
  margin: 18px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.subjective-list-title {
  color: #071833;
  text-align: left;
  font: 600 16px/18px "Noto Sans Bengali", sans-serif;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
  grid-column: 1/4;
  margin-left: 18px;

}
.subjective-list-button-title {
  color: #071833;
  text-align: left;
  font: 600 15px/19px "Noto Sans Bengali", sans-serif;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
  grid-column: 2/4;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 15px;
}
.subjective-list-sub-title {
  position: relative;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: #999999;

}

.subjective-list-arrow {
  text-align: right;
  margin-right: 15px;
  cursor: pointer;
  grid-column: -1;
}

.subjective-list-button-arrow {
  text-align: right;
  margin-right: 15px;
  cursor: pointer;
  grid-column: -1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.subjective-list-arrow {
  overflow: visible;
}
.subjective-list-rectangle {
  background: #F0EDF2 ;
}

.subjective-list .subjective-list-box:nth-child(2n) .subjective-list-rectangle {
  background: #EDF1F7 ;
}
.subjective-list .subjective-list-box:nth-child(3n) .subjective-list-rectangle {
  background: #F3D8D9 ;
}

.subjective-list-mobile .subjective-list-button:nth-child(odd) .subjective-list-button-icon {
  background: #EDF1F7 ;
}
.subjective-list-mobile .subjective-list-button:nth-child(even) .subjective-list-button-icon {
  background: #F3D8D9 ;
}
</style>